import React from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { grey900 } from "material-ui/styles/colors"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { EditorState, convertToRaw, ContentState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import htmlToDraft from "html-to-draftjs"
import _ from "lodash"
interface IProps {
    value: string
    handleSave(value: string): void
}
interface IState {
    value: string
    editorState: any
}

export default class HTMLEditTextDialog extends React.Component<IProps, IState> {
    private editor
    constructor(props: IProps) {
        super(props)
        const contentBlock = htmlToDraft(props.value)
        this.state = {
            value: props.value,
            editorState: contentBlock ?
                EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks)) :
                EditorState.createEmpty(),
        }
        autobind(this)
    }

    componentDidMount() {
        this.editor.focus()
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                actions={[
                    <FlatButton
                        data-intercom-target={"HTMLTextDialog-Btn-Ok"}
                        label={strings.OK}
                        primary
                        onTouchTap={() => this.props.handleSave(this.state.value === "<p></p>\n" ? "" : this.state.value)}
                    />
                ]}
            >
                <Editor
                    editorRef={elem => this.editor = elem}
                    editorState={this.state.editorState}
                    editorStyle={{ minHeight: 300, border: "1px solid #F1F1F1", borderRadius: 2, color: grey900 }}
                    toolbarStyle={{ color: grey900 }}
                    onEditorStateChange={editorState => this.setState({ editorState, value: draftToHtml(convertToRaw(editorState.getCurrentContent())) })}
                    toolbar={
                        {
                            options: ["inline", "blockType", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "history"],
                            inline: {
                                options: ["bold", "italic", "underline", "strikethrough", "monospace"]
                            },
                            list: {
                                options: ['unordered', 'ordered']
                            }
                        }
                    }
                />
            </Dialog>
        )
    }
}
